import React from "react";
import { isAuth } from "../../../helpers/general";
import { navigate } from "gatsby";
import { FromatNumberVIE} from "../../../utils/format";
import { useEffect, useState } from "react";
const CartMobileEmpty = () => {
    if (isAuth === true) {
        window.location.href = '/dang-nhap.html';
    }
    const [loading, setLoading] = useState(true);
    const [bixu, setBixu] = useState(0);
    const [he, setHe]= useState(0);
    useEffect(() => {
        setTimeout(()=>{
            setLoading(false)
        },3000);

        if(window.localStorage.getItem('bixu') && window.localStorage.getItem('bixu') !== null  && window.localStorage.getItem('bixu') !== undefined ){
            setBixu(FromatNumberVIE(window.localStorage.getItem('bixu')));
        }
        setHe(window.innerHeight-250);

    }, []);
    return (
        <>
            <div id="cart-css" >
            <div className="bg-white">
                    <div className="row header pdx-10 pdy-10 mgx-0">
                            <div className="col-3 pdl-20" onClick={() => navigate('/')}>
                                <i className="fa fa-chevron-left"></i>
                            </div>
                            <div className="col-6 text-center">
                                <span className="name-page">GIỎ HÀNG </span>
                            </div>
                    </div>
                    <div className="row pdy-10 pdx-30">
                        <div className="col-6 text-center">
                            <span className="text-normal-13-bland fw-bold text-selected">Tất cả</span>
                        </div>
                        <div onClick={() => navigate('/mobile/wishlist.html')} className="col-6 text-center">
                            <span className="text-normal-13-bland fw-bold">Yêu thích</span>
                        </div>
                    </div>
                </div>

                <div className="row mgt-10">
                    <div className="">
                        <div className="pdx-10 pdy-12 bg-white">
                            <ul className="bs4-order-tracking-mobile ">
                                <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon"/></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                <li id="delivery" className="step"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_none.png" alt="icon"/></div></div><span className="text-normal-12">Giao hàng</span></li>
                                <li id="payment" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_none.png" alt="icon"/></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                <li id="complate" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_none.png" alt="icon"/></div></div><span className="text-normal-12"> Thành công </span> </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="bg-white pdy-20" style={{height: he}}>
                    {
                        loading === true ? (<><div id="landing-web">
                        <div className="loading-page"  style={{textAlign:"center"}}>
                            <img src="/../images/loading.gif" alt="icon"/>
                        </div>
                    </div></>):(
                            <><div className="text-center pdt-20">
                            <img src="/../images/cart/iconcartempty.png" alt="icon" />
                        </div>
                        <div className="row text-center pdy-24 mgx-0">
                            <div className="col-12 in-f d-flex">
                                <span className="text-bold-12 line-hei-15">
                                    Bạn chưa có sản phẩm nào trong Giỏ hàng.
                                </span>
                            </div>
                            <div className="col-12 in-f d-flex">
                                <span className="text-bold-12 line-hei-15">
                                    Mua sắm thêm để nhận nhiều ưu đãi Bạn nhé.
                                </span>
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="btn-next-buy" onClick={() => navigate('/')}>
                                TIẾP TỤC MUA SẮM
                            </button>
                        </div></>
                        )
                    }
                    

                </div>

                {/* <div className="bg-white pdx-20 pdy-24">
                    <div className="text-center">
                        <span className="text-14-600">
                            Ba Mẹ hiện có <span className="text-14-yellow"> 
                            { bixu } Bixu</span> để đổi quà
                        </span>
                    </div>
                    <div className="col-12 mgy-20 in-f">
                        <div className="box-gift">
                            <div className="col-12 bow-tie">
                                <img src="/../images/product/bow_tie.png" alt="bowtie"/>
                            </div>
                            <div className="col-12 text-gift-now">
                                    <span>ĐỔI QUÀ NGAY</span>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default CartMobileEmpty